export default ({ type, formikProps: { values, setValues }, setIsOpen }) => {
  setValues({
    ...values,
    ...type.values,
  })

  setIsOpen(false)
}
